import { render, staticRenderFns } from "./FilterTagContainer.vue?vue&type=template&id=d27d3268&"
import script from "./FilterTagContainer.vue?vue&type=script&lang=ts&"
export * from "./FilterTagContainer.vue?vue&type=script&lang=ts&"
import style0 from "./FilterTagContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports